import React from 'react';
import { withRouter } from 'react-router-dom';
import ListLinkBox from '../components/UI/ListLinkBox';
import Breadcrumbs from '../components/UI/Breadcrumbs';

const HomeDefault = (props) => {
    return (
        <>
            <Breadcrumbs id="homeDefault" title={props?.title} subtitles={props?.subtitles} />
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px' }}>
                <ListLinkBox
                    options={props?.menu}
                />
            </div>
        </>
    );
};

export default withRouter(HomeDefault);
